import cleanedFilename from '~/util/cleanedFilename';

export default {
  HEADER_ROW: `${cleanedFilename(__filename)}-header-row`,
  CONTAINER: `${cleanedFilename(__filename)}-container`,
};
